import {ReactNode, useState} from "react";
import {Button, ButtonProps, CircularProgress} from "@mui/material";

interface LoadingButtonProps {
  onClick: () => Promise<void>;
  children: ReactNode;
  disabled?: boolean;
  props?: ButtonProps;
  variant?: "contained" | "outlined" | "text";
  disableFullWidth?: boolean;
}

export function LoadingButton({
                                onClick,
                                children,
                                disabled,
                                props,
                                variant = 'contained',
                                disableFullWidth
                              }: LoadingButtonProps) {
  const [isLoading, setIsLoading] = useState(false);
  
  return (
    <Button
      variant={variant}
      fullWidth={!disableFullWidth}
      disableElevation
      disabled={disabled || isLoading}
      onClick={async () => {
        setIsLoading(true);
        try {
          await onClick();
        } catch (error) {
          console.error("Failed to click document:", error);
        } finally {
          setIsLoading(false);
        }
      }}
      {...props}
    >
      {isLoading ? (
        <CircularProgress color={"inherit"} size={"20px"}/>
      ) : (
        children
      )}
    </Button>
  );
}
